import {useTopMenuStore} from '@frontend/stores'
import {Collapse} from 'swayok-react-mdb-ui-kit/components/Collapse/Collapse'
import {TopNavigationContent} from './TopNavigationContent'

// Верхнее меню навигации.
export function TopNavigation() {

    const show = useTopMenuStore(
        state => state.visible
    )

    return (
        <Collapse
            show={show}
            showImmediately
            tag="div"
            id="top-nav"
        >
            <TopNavigationContent />
        </Collapse>
    )
}
